module.exports = __webpack_public_path__ + "img/product12_1.3595b91a.png";